import { Component, inject } from '@angular/core';
import { AccordionDirective } from '../../directives/accordion.directive';
import { environment } from '../../../environments/environment';
import { NgClass, NgOptimizedImage } from '@angular/common';
import { RouterModule } from '@angular/router';
import { RedirectionService } from '../../services/redirection.service';

@Component({
    selector: 'app-tab-content',
    imports: [AccordionDirective, NgOptimizedImage, NgClass, RouterModule],
    templateUrl: './tab-content.component.html',
    styleUrl: './tab-content.component.scss'
})
export class TabContentComponent {
    assetsCDNUrl = environment.assetsCDNUrl;
    selectedTab: any = 0;
    _redirection = inject(RedirectionService);
    data: { description: string, items: { title: string; description: string; imageUrl: string; redirection: number; titleSubtext?: string; subtitle?: string }[] } = {
        description: "<p>Our comprehensive solutions are designed to meet your diverse financial needs.</p>",
        items: [
            {
                title: "Wealth Management",
                description: "<p>Explore tailored solutions, including Mutual Funds, Bonds, AIFs, PMS, Broking and Commodity Solutions, designed to grow and diversify your portfolio.</p>",
                imageUrl: "/assets/images/our-solutions/wealth-management.webp",
                redirection: 0
            }, {
                title: "Lending Solutions",
                description: "<p>Achieve your financial goals with loans for business and personal growth.</p>",
                imageUrl: "/assets/images/our-solutions/lending-solutions.webp",
                redirection: 1
            }, {
                // subtitle: "<p>(Coming Soon)</p>",
                title: "Protection Solutions",
                description: "<p>Safeguard your family’s future with our personalized life and general insurance policies.</p>",
                imageUrl: "/assets/images/our-solutions/protection-solutions.webp",
                redirection: 2,
                // titleSubtext: "(Coming Soon)"
            }, {
                title: "Global Investment Opportunities",
                description: "<p>Diversify your portfolio globally with offshore investments.</p>",
                imageUrl: "/assets/images/our-solutions/global-investment-opportunities.webp",
                redirection: 3
            }, {
                title: "Family Office & Estate Services",
                description: "<p>Secure your legacy with estate planning, trust creation, and professional  services for long-term wealth management.</p>",
                imageUrl: "/assets/images/our-solutions/family-office-and-estate-services.webp",
                redirection: 4
            }
        ]
    }

    handler_redirect(selectedTab: number) {
        this._redirection.solution.set(selectedTab);
        setTimeout(() => {
            this._redirection.handler_scroll('js-scrollContent');
        }, 500);
    }

}
